const constants = require('./constants');

const Segment = require('./Segment');

class File {
  constructor(id, name, version, user, company, segments, active) {
    this._id = parseInt(id, 10);
    this._name = name;
    this._version = parseInt(version, 10);
    this._user = user;
    this._company = company;
    this._segments = segments || [];
    this._active = (active === true || active === "true") || false;
    this._onChange = null;
  }

  addSegment(segment) {
    this._segments.push(segment);
    this.emitFileChanged();
  }

  replaceSegment(oldSegment, newSegment) {
    const index = this.segments.findIndex(segment => segment.hash === oldSegment.hash);

    if (index < 0) throw new Error('Could not replace segment. Please refresh the page');

    this._segments[index] = newSegment;
    newSegment.hash = oldSegment.hash;
    this.emitFileChanged();
  }

  removeSegmentByHash(hash) {
    const index = this.segments.findIndex(segment => segment.hash === hash);

    if (index > -1) {
      this._segments.splice(index, 1);
      this.emitFileChanged();
    }
  }

  markSegmentAsDeleted(hash) {
    const segment = this.getSegmentByHash(hash);
    segment.flag = constants.SEGMENT_DELETED;
    this.emitFileChanged();
  }

  get id() {
    return this._id;
  }

  get name() {
    return this._name;
  }

  get version() {
    return this._version;
  }

  get user() {
    return this._user;
  }

  get company() {
    return this._company;
  }

  get segments() {
    return this._segments;
  }

  get active() {
    return this._active;
  }

  set segments(value) {
    this._segments = value;
    this.emitFileChanged();
  }

  set name(value) {
    this._name = value;
    this.emitFileChanged();
  }

  set onChange(value) {
    this._onChange = value;
  }

  emitFileChanged() {
    if (this._onChange === null) return;
    this._onChange(this);
  }

  getSegmentByHash(hash) {
    return this._segments.find(segment => segment.hash === hash);
  }

  getSegmentByName(name) {
    return this._segments.find(segment => segment.getAttributeByName('description') === name);
  }

  getSegmentByOlr(olr) {
    return this._segments.find(segment => segment.olr === olr && segment.flag !== constants.SEGMENT_DELETED);
  }

  getTurnRestrictionByOlr(olr) {
    return this._segments.find(segment => segment.olr === olr && segment.flag !== constants.SEGMENT_DELETED && constants.SEGMENT_TYPE_TO_CATEGORY[segment.type] === 'Maneuver')
  }

  serialize() {
    const filePlainObject = {
      id: this._id,
      name: this._name,
      version: this._version,
      user: this._user,
      company: this._company,
      segments: [],
      active: this._active
    };

    filePlainObject.segments = this._segments.map(segment => segment.serialize());
    return JSON.stringify(filePlainObject);
  }

  static deserialize(fileRaw) {
    const file = JSON.parse(fileRaw);
    const segments = file.segments.map(segment => Segment.deserialize(segment));

    return new File(file.id, file.name, file.version, file.user, file.company, segments, file.active);
  }
}

module.exports = File;
